import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { VehiclePartsSearchPagination } from '../src/modules/ads/pagination/components'
import { GroupsListWithNewParts } from 'SRC/modules/groups/components'
import { GroupsMenuMobile } from 'SRC/modules/categories/components'
import { fetchVehicleParts, setError } from 'SRC/modules/vehicleParts/list/actions'
import { List as PartsList, BottomNavigation } from 'SRC/modules/vehicleParts/list/components'
import { Sidebar as VehiclePartSidebar } from 'SRC/modules/vehicleParts/detail/components'
import { withRouter } from 'next/router'
import withTranslation from 'next-translate/withTranslation'
import { VehiclPartsFilterGume } from 'SRC/modules/vehicleParts/filter'
import { fetchFilteredFields } from 'SRC/modules/vehicleParts/filter/actions'
import { getUrlValues } from 'SRC/modules/vehicleParts/utils/vehiclePartsUtils'
import { Page, Page404 } from '../src/ui'
import initialState from '../src/modules/redux/initialState'
import { fetchInfo, setInfo } from '../src/modules/users/detail/actions'
import { deepCopy } from '../src/utils'
import config from '../src/config/config.json'

import translations from '../public/data/translations.json'

class VehiclPartsSearchPage extends React.Component {
	componentDidMount() {
		setTimeout(() => {
			window.scrollTo(0, 0)
		}, 200)
	}

	componentDidUpdate(prevProps) {
		if (prevProps?.router?.asPath !== this.props?.router?.asPath) {
			setTimeout(() => {
				window.scrollTo(0, 0)
			}, 200)
		}
	}

	static async getInitialProps(ctx) {
		const { store, query } = ctx

		const locale = ctx?.locale?.toUpperCase() || query?.locale?.toUpperCase() || 'ME'

		const group = 'gume'
		const textFilter = query?.['text-filter'] || ''

		const urlValues = getUrlValues(query)

		const { page } = urlValues

		const isMobileDevice = store.getState().common.isMobileDevice

		const userRequestParams = { username: 'YN483', locale }
		await store.dispatch(fetchInfo(userRequestParams))

		let isPageExists = true

		const payload = { ...urlValues, locale }

		await store.dispatch(fetchFilteredFields({ group, payload }))


		let filtersCount = Object.keys(urlValues).filter(key => {
			if (key === 'page') return false
			if (key === 'group') return false
			if (urlValues[key]) return true

			return false
		}).length

		filtersCount += 1

		const requestParams = {
			page: Number(page),
			limit: 36,
			...payload
		}

		if (group) requestParams.group = group
		if (textFilter) requestParams.text_filter = textFilter

		await store.dispatch(fetchVehicleParts(requestParams))

		return {
			title: isPageExists
				? `${translations.noviDjeloviTitle[query?.locale?.toUpperCase() || 'ME']}`
				: config.pages.notFoundTitle,
			isPageExists,
			isMobileDevice,
			filtersCount,
			group,
			filterValues: urlValues || {},
			state: VehiclPartsSearchPage.getPageState(store, isPageExists)
		}
	}

	static getPageState(store, isPageExists = false) {
		const state = deepCopy(initialState)
		if (store) {
			const currentState = store.getState()

			state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
			state.user.profile.error = currentState.user.profile.error
			state.user.profile.info = currentState.user.profile.info
			state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
			state.user.profile.savedFilters = currentState.user.profile.savedFilters
			state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
			state.user.profile.packageInactiveMessage = currentState.user.profile.packageInactiveMessage
			state.user.profile.priceTypes = currentState.user.profile.priceTypes
			state.user.listSidebar = currentState.user.listSidebar
			state.user.detail.info = currentState.user.detail.info

			state.common.transitions = currentState.common.transitions
			state.common.router = currentState.common.router
			state.common.is404 = !isPageExists
			state.common.isMobileDevice = currentState.common.isMobileDevice
			state.common.userTypes = currentState.common.userTypes
			state.common.pageMetaTags = currentState.common.pageMetaTags
			state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

			state.groups.elements = currentState.groups.elements

			state.categories.currentSubcategory = currentState.categories.currentSubcategory

			if (isPageExists) {
				state.vehicleParts.list = currentState.vehicleParts.list
				state.vehicleParts.filter = currentState.vehicleParts.filter
			}

			state.geoObjects.countries = currentState.geoObjects.countries
			state.geoObjects.regions = currentState.geoObjects.regions
			state.geoObjects.cities = currentState.geoObjects.cities

			state.form = currentState.form
		}
		return state
	}

	render() {
		const {
			isPageExists,
			isMobileDevice,
			filterValues,
			filtersCount,
			group,
			i18n: { t }
		} = this.props

		const noAdsMessage = t('common:vehicle_parts_no_products_available')

		return isPageExists ? (
			<Page className='main-content main-content-full'>
				<div className='vehicle-parts-content'>
					<div className='vehicle-parts-content-main'>

						{!isMobileDevice ? <GroupsListWithNewParts /> : (
							<>
								<GroupsMenuMobile
									filtersCount={filtersCount}
									vehiclePartsGroup={group}
									vehiclePartsCategory={filterValues?.category || ''}
									vehiclePartsFilterValues={filterValues}
								/>
							</>
						)}

						<VehiclPartsFilterGume filterValues={filterValues} />

						<PartsList noAdsMessage={noAdsMessage} />
						<VehiclePartsSearchPagination />

						{isMobileDevice ? <BottomNavigation filtersCount={filtersCount} /> : null}
					</div>
					<VehiclePartSidebar />
				</div>
			</Page>
		) : <Page404 />
	}
}

VehiclPartsSearchPage.propTypes = {
	isPageExists: PropTypes.bool.isRequired,
	group: PropTypes.string.isRequired,
	filtersCount: PropTypes.number.isRequired
}

VehiclPartsSearchPage.defaultProps = {
	isPageExists: false
}

const enhance = compose(
	withRouter,
	withTranslation
)

export default enhance(VehiclPartsSearchPage)